import React, { useState, useCallback } from 'react';
import { createPortal } from 'react-dom';

import Alert from 'react-bootstrap/Alert';

import './style.scss';

export const useNotification = () => {
  const [notification, setNotification] = useState({})
  const showNotification = useCallback(
    (data) => {
      const { type, message } = data;
      if (type && message) {
        setNotification(data)
      }
    }, []
  );
  const notifySuccess = useCallback(
    (data) => {
      showNotification({ type: "success", ...data })
    }, [showNotification]
  );
  const notifyError = useCallback(
    (data) => {
      showNotification({ type: "danger", ...data })
    }, [showNotification]
  );
  const onClose = useCallback(() => setNotification({}), []);

  return {
    showNotification,
    notifySuccess,
    notifyError,
    onClose,
    notification,
  };
};

const Notification = ({ id, type, header, onClose, message }) => {
  return createPortal(
    <div className='notif-container d-flex justify-content-center'>
      <Alert
        key={id}
        show={!!onClose && !!message}
        variant={type}
        className="align-self-center col-9 col-lg-4"
        onClose={onClose}
        dismissible={!!onClose}
      >
        {header && <Alert.Heading>{header}</Alert.Heading>}
        <div>{Array.isArray(message) ? <ul>{message.map(errorMsg => <li>{errorMsg}</li>)}</ul> : message}</div>
      </Alert>
    </div>,
    document.body
  );
};

export default Notification;
